/**
 * @internal
 */
export var SearchUrlSuffix = {
    Families: 'families',
    Groups: 'groups',
    Root: '',
    Prioritize: 'prioritize',
    Suggest: 'suggest',
    SuggestPrioritize: 'suggest-prioritize',
};
